import Header from '@/components/MedicalKorUpload/Header';
import styled from 'styled-components';
import IMG_GUIDE_5 from '@/assets/korUploadFile/img_guide_5.png';
import { Button } from '@successmode-ktp/kui';
import UploadFile from '@/components/MedicalKorUpload/UploadFile';
import { useHistory } from 'react-router-dom';
import { routes } from '@/constant/routes.const';
import { useSelector } from 'react-redux';
import { useMutation } from 'react-query';
import { IGlobalState } from '@/store';
import { uploadTicket } from '@/api';
import { useState } from 'react';
import { resizeFile } from '@repo/utils';
import UploadedModal from '@/components/MedicalKorUpload/Uploaded.modal';
import SubstituteGuideModal from '@/components/MedicalKorUpload/SubstituteGuide.modal';
import UploadCheckModal from '@/components/korUploadFile/UploadCheck.modal';

const Index = () => {
  const history = useHistory();
  const { passportNumber } = useSelector((state) => state) as IGlobalState;
  const { mutate: mutateUploadTicket } = useMutation(uploadTicket);
  const [files, setFiles] = useState<File[]>([]);
  const [isUpload, setIsUpload] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCheck, setIsOpenCheck] = useState(false);

  const onSaveTicket = async () => {
    if (passportNumber && files.length !== 0) {
      const passportNumberBlob = new Blob(
        [JSON.stringify({ passportNumber })],
        {
          type: 'application/json',
        },
      );
      const ticketUploadData = new FormData();
      const resizedFilesPromise = files.map(async (file) => {
        return await resizeFile(file);
      });
      const resizedfile = await Promise.all(resizedFilesPromise);
      ticketUploadData.append('request', passportNumberBlob);
      files.forEach((file: File) => {
        ticketUploadData.append('file', file);
      });

      mutateUploadTicket(ticketUploadData, {
        onSuccess: () => {
          setIsUpload(true);
        },
        onError: () => {
          setIsUpload(false);
        },
      });
    }
  };

  return (
    <Wrapper>
      <Header title='출입국사실증명서 업로드하기' />
      <Container>
        <Img src={IMG_GUIDE_5} alt='' />
        <Text>출입국사실증명서 예시</Text>
        <UploadFile onChange={(v) => setFiles(v)} />
        <ExplainWrapper>
          <ExplainText>
            출입국사실증명서를 발급받지 못하는 경우 대체할 자료들을
            첨부해주세요.
          </ExplainText>
          <Button
            type='button'
            size='sm'
            theme='mono'
            style={{
              width: 'fit-content',
              whiteSpace: 'nowrap',
              padding: '0 12px',
            }}
            onClick={() => setIsOpen(true)}
          >
            대체서류 보기
          </Button>
        </ExplainWrapper>
        <ButtonWrapper>
          <Button
            type='button'
            size='lg'
            variant='line'
            onClick={() => history.push(routes.uploadKorFileGuide)}
            style={{ gap: '8px' }}
          >
            다운로드 방법
          </Button>
          <Button
            type='button'
            size='lg'
            onClick={() => setIsOpenCheck(true)}
            disabled={files.length === 0}
          >
            업로드하기
          </Button>
        </ButtonWrapper>
      </Container>
      <UploadedModal
        isOpen={isUpload}
        onClose={() => {
          setIsUpload(false);
          history.push(routes.medicalHome);
        }}
      />
      {isOpen && <SubstituteGuideModal onClick={() => setIsOpen(false)} />}
      <UploadCheckModal
        isOpen={isOpenCheck}
        onClose={() => setIsOpenCheck(false)}
        onClick={() => {
          onSaveTicket();
          setIsOpenCheck(false);
        }}
      />
    </Wrapper>
  );
};
export default Index;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 40px;
`;

const Container = styled.div`
  width: 375px;
  padding: 110px 20px 0;
  @media ${(props) => props.theme.mobile} {
    width: 100%;
  }
`;

const Text = styled.p`
  color: #999;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
  text-align: center;
  margin-bottom: 24px;
`;

const Img = styled.img`
  display: block;
  width: 200px;
  margin: 24px auto 8px;
`;

const ExplainWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 16px 0 64px;
`;

const ExplainText = styled.p`
  color: var(--KTP-Grayscale-Gray_05, #777);
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
